// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KRAAddressModal_modalOverlay__GRadV {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  padding: 1rem;
}

.KRAAddressModal_modalContent__wKtGp {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  animation: KRAAddressModal_modalFadeIn__ChFR2 0.3s ease;
}

@keyframes KRAAddressModal_modalFadeIn__ChFR2 {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.KRAAddressModal_modalTitle__DnVlq {
  color: #fd5e63;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  text-align: center;
}

.KRAAddressModal_addressContainer__OAkA6 {
  margin-bottom: 1.5rem;
}

.KRAAddressModal_addressField__OiWRJ {
  margin-bottom: 1rem;
  flex: 1 1;
}

.KRAAddressModal_addressField__OiWRJ label {
  display: block;
  color: #fd5e63;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.KRAAddressModal_addressField__OiWRJ .KRAAddressModal_value__dDtNu {
  color: #333;
  font-size: 1rem;
  padding: 0.75rem;
  background-color: #f5f5f5;
  border-radius: 4px;
  min-height: 2.5rem;
  word-wrap: break-word;
  border: 1px solid #e0e0e0;
}

.KRAAddressModal_addressRow__zN5tN {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.KRAAddressModal_proceedButton__b4z0L {
    background-image: linear-gradient(to top, #f73439, #f8777b);
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    padding: 12px 40px;
    width: 200px;
    margin: 20px auto;
    display: block;
    transition: all 0.3s ease;
    transform: translateY(0);
}

.KRAAddressModal_proceedButton__b4z0L:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(247, 52, 57, 0.25);
}

@media (max-width: 480px) {
    .KRAAddressModal_proceedButton__b4z0L {
        width: 100%;
        max-width: 280px;
        padding: 12px 24px;
        font-size: 0.9375rem;
    }
}
@media (max-width: 480px) {
  .KRAAddressModal_modalContent__wKtGp {
    padding: 1rem;
  }

  .KRAAddressModal_modalTitle__DnVlq {
    font-size: 1.125rem;
  }

  .KRAAddressModal_addressField__OiWRJ label {
    font-size: 0.8125rem;
  }

  .KRAAddressModal_addressField__OiWRJ .KRAAddressModal_value__dDtNu {
    font-size: 0.9375rem;
    padding: 0.625rem;
  }

  .KRAAddressModal_addressRow__zN5tN {
    flex-direction: column;
    gap: 0.5rem;
  }

  .KRAAddressModal_proceedButton__b4z0L {
    padding: 0.75rem;
    font-size: 0.9375rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organism/KRAAddressModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,uDAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;IACI,2DAA2D;IAC3D,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;IACxB;AACJ;AACA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9;\n  padding: 1rem;\n}\n\n.modalContent {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 500px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n  animation: modalFadeIn 0.3s ease;\n}\n\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modalTitle {\n  color: #fd5e63;\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.addressContainer {\n  margin-bottom: 1.5rem;\n}\n\n.addressField {\n  margin-bottom: 1rem;\n  flex: 1;\n}\n\n.addressField label {\n  display: block;\n  color: #fd5e63;\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n}\n\n.addressField .value {\n  color: #333;\n  font-size: 1rem;\n  padding: 0.75rem;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  min-height: 2.5rem;\n  word-wrap: break-word;\n  border: 1px solid #e0e0e0;\n}\n\n.addressRow {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.proceedButton {\n    background-image: linear-gradient(to top, #f73439, #f8777b);\n    font-size: 16px;\n    font-weight: 500;\n    color: #fff;\n    border-radius: 8px;\n    border: none;\n    cursor: pointer;\n    padding: 12px 40px;\n    width: 200px;\n    margin: 20px auto;\n    display: block;\n    transition: all 0.3s ease;\n    transform: translateY(0);\n}\n\n.proceedButton:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(247, 52, 57, 0.25);\n}\n\n@media (max-width: 480px) {\n    .proceedButton {\n        width: 100%;\n        max-width: 280px;\n        padding: 12px 24px;\n        font-size: 0.9375rem;\n    }\n}\n@media (max-width: 480px) {\n  .modalContent {\n    padding: 1rem;\n  }\n\n  .modalTitle {\n    font-size: 1.125rem;\n  }\n\n  .addressField label {\n    font-size: 0.8125rem;\n  }\n\n  .addressField .value {\n    font-size: 0.9375rem;\n    padding: 0.625rem;\n  }\n\n  .addressRow {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .proceedButton {\n    padding: 0.75rem;\n    font-size: 0.9375rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `KRAAddressModal_modalOverlay__GRadV`,
	"modalContent": `KRAAddressModal_modalContent__wKtGp`,
	"modalFadeIn": `KRAAddressModal_modalFadeIn__ChFR2`,
	"modalTitle": `KRAAddressModal_modalTitle__DnVlq`,
	"addressContainer": `KRAAddressModal_addressContainer__OAkA6`,
	"addressField": `KRAAddressModal_addressField__OiWRJ`,
	"value": `KRAAddressModal_value__dDtNu`,
	"addressRow": `KRAAddressModal_addressRow__zN5tN`,
	"proceedButton": `KRAAddressModal_proceedButton__b4z0L`
};
export default ___CSS_LOADER_EXPORT___;
